import Card from 'components/atoms/Card';
import Input from 'components/molecules/Input';
import { ChangeEvent, MutableRefObject, ReactNode, useContext } from 'react';
import Button from 'components/atoms/Button';
import { HubAuthoringContext, HubAuthoringDispatchContext } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/reducer';
import { ActionType } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/action';
import HubSectionColorSettings from './HubSectionColorSettings';

interface HubSectionFormProps {
  children?: ReactNode;
  index: number;
  isLast: boolean;
  innerRef?: MutableRefObject<HTMLInputElement>;
}

export enum SortDirection {
  Up = 'Up',
  Down = 'Down',
}

function HubSectionForm({ children, index, isLast, innerRef }: HubSectionFormProps) {
  const {
    hubUpsertParams: { sections },
  } = useContext(HubAuthoringContext);
  const dispatch = useContext(HubAuthoringDispatchContext);

  return (
    <Card className="flex p-0 mt-4">
      <div className="flex-column w-3/4 p-4">
        <div>
          <Input
            ref={innerRef}
            label="Section Title (Optional)"
            subLabel="Max Characters 40"
            value={sections[index].title ?? null}
            maxLength={40}
            characterLimit={40}
            className="mb-2"
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              dispatch({
                type: ActionType.setSectionTitle,
                payload: {
                  index,
                  title: event.target.value,
                },
              });
            }}
          />
          <Input
            label="Section Description (Optional)"
            subLabel="Max 250 Characters"
            value={sections[index].description ?? null}
            maxLength={250}
            characterLimit={250}
            className="mb-2"
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              dispatch({
                type: ActionType.setSectionDescription,
                payload: {
                  index,
                  description: event.target.value,
                },
              });
            }}
          />
        </div>
        <div> {children} </div>
      </div>

      <div className="border-l border-black p-4">
        <div className="flex justify-end mb-2">
          <Button
            dataDurableId={`${index}-hubSectionUpButton`}
            icon="arrow-up"
            size="xs"
            type="tertiary"
            className={`ml-2 ${index === 0 ? 'pointer-events-none opacity-60' : ''}`}
            disabled={index === 0}
            hideHighlight
            onClick={() => {
              dispatch({
                type: ActionType.orderSections,
                payload: {
                  index,
                  isLast,
                  sortDirection: SortDirection.Up,
                },
              });
            }}
          />
          <Button
            dataDurableId={`${index}-hubSectionDownButton`}
            icon="arrow-down"
            size="xs"
            type="tertiary"
            className={`ml-2 ${isLast ? 'pointer-events-none opacity-60' : ''}`}
            disabled={isLast}
            hideHighlight
            onClick={() => {
              dispatch({
                type: ActionType.orderSections,
                payload: {
                  index,
                  isLast,
                  sortDirection: SortDirection.Down,
                },
              });
            }}
          />
          <Button
            dataDurableId={`${index}-hubSectionDeleteButton`}
            icon="trash"
            size="xs"
            type="tertiary"
            className="ml-2"
            hideHighlight
            onClick={() => {
              dispatch({
                type: ActionType.deleteSection,
                payload: {
                  index,
                },
              });
            }}
          />
        </div>
        <HubSectionColorSettings index={index} />
      </div>
    </Card>
  );
}

export default HubSectionForm;
